import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { getAuthCookie } from "../../utils/authCookies";
// import "react-toastify/dist/ReactToastify.css";

type TaxRule = {
  _id: string;
  country: string;
  state: string;
  stateCode: string;
  county: string;
  countyCode: string;
  zipCodes: string[];
  taxRate: number;
  comments: string;
  status: string;
};

// type TaxGroup = {
//   id: string;
//   name: string;
//   tax_rules: TaxRule[];
//   status: string;
// };
type TaxGroup = {
  _id: string;
  name: string;
  status: string;
  tax_rules: { _id: string; country: string; taxRate: number }[];
};


const SignageViewTaxGroup = () => {
  const { taxId } = useParams<{ taxId: string }>();
  const token = getAuthCookie("sessionToken");
  const [taxGroup, setTaxGroup] = useState<TaxGroup | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>("");
  const navigate = useNavigate();
  const location = useLocation();
  const isSignageTeammember = location.pathname.includes('/signageteammember');
  const baseRoute = isSignageTeammember ? '/signageteammember' : '/signage';
  useEffect(() => {
    if (location.state?.successMessage) {
      toast.success(location.state.successMessage);
    }
  }, [location.state]);

  useEffect(() => {
    const fetchGroupData = async () => {
      setLoading(true); // ✅ start loading at the beginning

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/tax-groups/${taxId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch tax group data");
        }

        const data = await response.json();

        // ✅ Ensure tax_rules is always an array to avoid undefined issues
        setTaxGroup({
          ...data,
          tax_rules: data.tax_rules ?? [],
        });
      } catch (error) {
        console.error("Error fetching group data:", error);
        setError(
          error instanceof Error ? error.message : "An unknown error occurred"
        );
      } finally {
        setLoading(false); // ✅ always stop loading
      }
    };

    if (taxId) {
      fetchGroupData();
    }
  }, [taxId, token]);


  const handleDeleteTaxRate = async (groupId: string, ruleId: string) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/customer-groups/${groupId}/users/${ruleId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) throw new Error("Failed to delete agent");

      //   setTaxGroup((prev) => {
      //     if (!prev) return null;
      //     return {
      //       ...prev,
      //       allowed_user_ids: prev.allowed_user_ids?.filter(
      //         (agent) => agent.user_id !== agentId
      //       ),
      //     };
      //   });

      toast.success("Agent deleted successfully.");
    } catch (err) {
      toast.error("Failed to delete agent.");
      setError(
        err instanceof Error ? err.message : "An unknown error occurred"
      );
    } finally {
      setLoading(false);
    }
  };

  //   if (loading) return <div>Loading Group Data...</div>;
  //   if (!group) return <div>Group data not found.</div>;

  return (
    <div className="content">
      <div className="">
        <h3 className="m-0 text-center d-flex justify-content-center fw-bold addheaders p-0">Tax Group Details</h3>
      </div>
      {/* <h2 className="text-center">Tax Group Details</h2> */}
      <div className="row justify-content-center">
        <div className="col-md-10 col-lg-10 col-xl-9">
          <div className="card shadow-sm">
            <div className="card-body">
              <table className="table table-bordered align-middle">
                <tbody>
                  <tr className="table-secondary">
                    <th className="text-center table-headers" colSpan={4}>Group Information</th>
                  </tr>
                  <tr>
                    <th className="text-center table-headers" style={{ width: "20%" }}>Group Name:</th>
                    <td className="text-center table-cells" style={{ width: "30%" }}>{taxGroup?.name}</td>
                    <th className="text-center table-headers" style={{ width: "20%" }}>Status:</th>
                    <td className="text-center table-cells" style={{ width: "30%" }}>Active</td>
                  </tr>
                  <tr className="table-secondary">
                    <th className="text-center table-headers" colSpan={4}>Tax Rules</th>
                  </tr>
                  {taxGroup && (
                    taxGroup.tax_rules.length > 0 ? (
                      taxGroup.tax_rules.map((rule, idx) => (
                        <tr key={rule._id}>
                          <td className="text-center table-cells" colSpan={4}>
                            <div className="d-flex justify-content-between">
                              <span>{idx + 1}. {rule.country}</span>
                              <span>{rule.taxRate}%</span>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center table-cells">
                          No tax rules added.
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
               <div className="row mb-3 rcust-margin-4">
                                                <div className="col-md-12 d-flex justify-content-between">
                                                    <div></div>
                                                      <button
                                                        className="btn btn-outline-secondary br-8 backbutton"
                                                        type="button"
                                                        onClick={() => navigate(-1)}
                                                    >
                                                        Back
                                                    </button>
                                                </div>
                                            </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    // <div className="content">
    //   <div className="card">
    //     <div className="card-body">
    //       <h2>
    //         {/* {group?.name} ({group?.allowed_user_ids?.length} agents) */}
    //       </h2>
    //       <div className="row justify-content-center">
    //         <div className="col-md-12 col-lg-12 col-xl-12">
    //           <div className="card mt-4 card-bg-fill">
    //             <div className="card-body p-4">
    //               <div className="table-container">
    //                 <table className="table">
    //                   <tbody>
    //                     <tr>
    //                       <th colSpan={3}>Group Information </th>
    //                       <td className="text-center table-cells">
    //                         {/* <Link
    //                           to={`/signage/addGroupAgent/${taxGroup?.id}`}
    //                           className="btn btn-secondary waves-effect waves-light"
    //                         >
    //                           Add Tax Rule
    //                         </Link> */}
    //                       </td>
    //                     </tr>
    //                     <tr>
    //                       <th>Group Name: </th>
    //                       <td>{taxGroup?.name}</td>
    //                       <th>Status: </th>
    //                       {/* <td>{group.status === "Active" ? "Active" : "Inactive"}</td> */}
    //                       <td>Active</td>
    //                     </tr>
    //                     <tr>
    //                       <th>Tax Rules</th>
    //                       <td colSpan={3}>
    //                         {taxGroup && taxGroup?.tax_rules?.map((rule) => (
    //                           <div
    //                             key={rule._id}
    //                             className="d-flex justify-content-between mb-3 border-bottom"
    //                           >
    //                             <p>
    //                               {rule?.country } ({rule?.taxRate}%)
    //                             </p>
    //                             {/* <button
    //                               onClick={() =>
    //                                 window.confirm(
    //                                   "Are you sure you want to delete this agent?"
    //                                 ) &&
    //                                 handleDeleteTaxRate(taxGroup.id, rule._id)
    //                               }
    //                               className="btn btn-danger waves-effect waves-light"
    //                             >
    //                               <i className="ri-delete-bin-fill align-bottom me-2"></i>
    //                             </button> */}
    //                           </div>
    //                         ))}
    //                       </td>
    //                     </tr>
    //                   </tbody>
    //                 </table>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default SignageViewTaxGroup;
